import { render } from "./InfoActiveBox.vue?vue&type=template&id=c283a940&scoped=true&ts=true"
import script from "./InfoActiveBox.vue?vue&type=script&lang=ts"
export * from "./InfoActiveBox.vue?vue&type=script&lang=ts"

import "./InfoActiveBox.vue?vue&type=style&index=0&id=c283a940&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c283a940"]])

export default __exports__